/** Clear only Hub Central state that belongs to the current signed-in identity.
 * Never clear the entire origin: other applications and Okta may share it.
 * In particular, Okta tokens must remain available until the end-session request starts.
 */
export function clearPortalSessionState(): void {
  const sessionKeys = [
    'hubCentral.selectedPartnerId',
    'hubCentral.approverAlertDismissed',
    'hub-central.assistant.login-introduction-dismissed.v1',
  ];
  for (const key of sessionKeys) {
    try { sessionStorage.removeItem(key); } catch { /* Storage can be blocked. */ }
  }
  try { localStorage.removeItem('hubCentral.lastActivity'); } catch { /* Storage can be blocked. */ }
}
